import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import Box from '@mui/material/Box';

function RegisterForm() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
      <SignUp routing="hash" />
    </Box>
  );
}

export default RegisterForm;
